export function forwardRef(wrapper) {
    return {
        unwrap: wrapper,
    };
}
export function isForwardRef(thing) {
    return !!thing && typeof thing.unwrap === 'function';
}
export function normalizeForwardRef(id) {
    if (isForwardRef(id)) {
        return id.unwrap();
    }
    return id;
}
//# sourceMappingURL=dependencyForwardRef.js.map